<template>
    <el-dialog
        title="图片上传"
        :visible.sync="cropperDialog2"
        width="40%"
        :before-close="handleClose"
    >
        <div class="cropper">
            <div style="display:flex;">
                <!-- <div class="info-item" style="flex:1;">
          <div
            style="width:120px;height:120px;border-radius:50%;overflow:hidden;margin-left:123px;border:1px solid #ddd"
          >
            <img style="width:120px;height:120px;" :src="headImg" alt="头像">
          </div>
        </div>-->
                <div
                    class="info-item"
                    style="flex:1;margin-top:30px;"
                >
                    <div class="icons">
                        <label
                            class="btn btn-orange btnLabel"
                            for="uploads"
                            style="display:inline-block;width: 70px;padding: 0;text-align: center;line-height: 28px;"
                        >选择图片</label>

                        <input
                            type="file"
                            id="uploads"
                            :value="imgFile"
                            style="position:absolute; clip:rect(0 0 0 0);"
                            accept="image/png, image/jpeg, image/gif, image/jpg"
                            @change="uploadImg($event, 1)"
                        />
                        <input
                            type="button"
                            class="oper"
                            style="height:20px;width:23px;font-size:20px;margin:3px 5px;"
                            value="+"
                            title="放大"
                            @click="changeScale(1)"
                        />
                        <input
                            type="button"
                            class="oper"
                            style="height:20px;width:23px;font-size:20px;margin:3px 5px;"
                            value="-"
                            title="缩小"
                            @click="changeScale(-1)"
                        />
                        <input
                            type="button"
                            class="oper"
                            style="height:20px;width:23px;font-size:20px;margin:3px 5px;"
                            value="↺"
                            title="左旋转"
                            @click="rotateLeft"
                        />
                        <input
                            type="button"
                            class="oper"
                            style="height:20px;width:23px;font-size:20px;margin:3px 5px;"
                            value="↻"
                            title="右旋转"
                            @click="rotateRight"
                        />
                        <input
                            type="button"
                            class="oper"
                            style="height:20px;width:23px;font-size:20px;margin:3px 5px;"
                            value="↓"
                            title="下载"
                            @click="down('blob')"
                        />
                        <input
                            type="button"
                            class="btn btn-blue uploadBtn"
                            value="上传头像"
                            @click="finish('blob')"
                        />
                    </div>

                    <div
                        class="line"
                        style="margin-top: 85px;"
                    >
                        <div
                            class="cropper-content"
                            style="margin-top:-60px;display:flex"
                        >
                            <div
                                class="cropper"
                                :style="{'width':'200px','height':200/scale+'px'}"
                            >
                                <VueCropper
                                    ref="cropper"
                                    :img="option.img"
                                    :outputSize="option.size"
                                    :outputType="option.outputType"
                                    :info="true"
                                    :full="option.full"
                                    :canMove="option.canMove"
                                    :canMoveBox="option.canMoveBox"
                                    :original="option.original"
                                    :autoCrop="option.autoCrop"
                                    :autoCropWidth="160"
                                    :autoCropHeight="160/scale"
                                    :fixedBox="option.fixedBox"
                                    @realTime="realTime"
                                    @imgLoad="imgLoad"
                                    :canScale="true"
                                    :high="false"
                                    :enlarge="autoCropWidth/160"
                                ></VueCropper>
                            </div>
                            <div style="margin-left:20px;">
                                <div
                                    class="show-preview"
                                    :style="{'width': '160px', 'height':160/scale+'px',  'overflow': 'hidden'}"
                                >
                                    <div
                                        :style="previews.div"
                                        class="preview"
                                    >
                                        <img
                                            :src="previews.url"
                                            :style="previews.img"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
// import { getMessage } from "@/api/getData";
import { VueCropper } from "vue-cropper";
// import myUpload from 'vue-image-crop-upload';

export default {
    data() {
        return {
            cropperDialog2: false,
            headImg: "",
            //剪切图片上传
            crap: false,
            previews: {},
            option: {
                img: "",
                outputSize: 0.4, //剪切后的图片质量（0.1-1）
                full: false, //输出原图比例截图 props名full
                outputType: "png",
                canMove: true,
                original: false,
                canMoveBox: false,
                autoCrop: true,
                // autoCropWidth: 150,
                // autoCropHeight: 250,
                fixedBox: true,
                high: false
            },
            fileName: "", //本机文件地址
            downImg: "#",
            imgFile: "",
            uploadImgRelaPath: "" //上传后的图片的地址（不带服务器域名）
        };
    },
    props: {
        autoCropWidth: {
            type: Number,
            default: 150
        },
        autoCropHeight: {
            type: Number,
            default: 250
        },
        cropperDialog: {
            default: false
        }
    },
    computed: {
        scale: function() {
            return this.autoCropWidth / this.autoCropHeight;
        }
    },
    components: {
        VueCropper
    },
    methods: {
        //关闭diglog
        handleClose() {
            this.cropperDialog2 = false;
        },
        //放大/缩小
        changeScale(num) {
            num = num || 1;
            this.$refs.cropper.changeScale(num);
        },
        //坐旋转
        rotateLeft() {
            this.$refs.cropper.rotateLeft();
        },
        //右旋转
        rotateRight() {
            this.$refs.cropper.rotateRight();
        },
        //上传图片（点击上传按钮）
        finish(type) {
            let _this = this;
            let formData = new FormData();
            // 输出
            if (type === "blob") {
                this.$refs.cropper.getCropBlob(data => {
                    console.log(data, "data");
                    let img = window.URL.createObjectURL(data);
                    this.model = true;
                    this.modelSrc = img;
                    formData.append("file", data, this.fileName);
                    let upload = {
                        index: 0,
                        data: {
                            item: {
                                value: ""
                            }
                        },
                        file: {
                            name: this.fileName,
                            type: data.type,
                            data: data
                        }
                    };
                    this.$emit("upload-callback", upload, 1);
                });
            } else {
                this.$refs.cropper.getCropData(data => {
                    this.model = true;
                    this.modelSrc = data;
                });
            }
        },
        // 实时预览函数
        realTime(data) {
            this.previews = data;
        },
        //下载图片
        down(type) {
            var aLink = document.createElement("a");
            aLink.download = "author-img";
            if (type === "blob") {
                this.$refs.cropper.getCropBlob(data => {
                    this.downImg = window.URL.createObjectURL(data);

                    aLink.href = window.URL.createObjectURL(data);
                    aLink.click();
                });
            } else {
                this.$refs.cropper.getCropData(data => {
                    this.downImg = data;
                    aLink.href = data;
                    aLink.click();
                });
            }
        },
        //选择本地图片
        uploadImg(e, num) {
            var _this = this;
            //上传图片
            var file = e.target.files[0];
            _this.fileName = file.name;
            const isLt1M = file.size / 1024 / 1024 <= 1;
            if (!isLt1M) {
                this.$alert("图片过大，请上传1M以内的图片", {
                    confirmButtonText: "确定"
                });
                return false;
            } else {
                if (
                    !/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(
                        e.target.value
                    )
                ) {
                    alert("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
                    return false;
                }
                var reader = new FileReader();
                reader.onload = e => {
                    let data;
                    if (typeof e.target.result === "object") {
                        // 把Array Buffer转化为blob 如果是base64不需要
                        data = window.URL.createObjectURL(
                            new Blob([e.target.result])
                        );
                    } else {
                        data = e.target.result;
                    }
                    if (num === 1) {
                        _this.option.img = data;
                    } else if (num === 2) {
                        _this.example2.img = data;
                    }
                };
                // 转化为base64
                // reader.readAsDataURL(file)
                // 转化为blob
                reader.readAsArrayBuffer(file);
            }
        },
        imgLoad(msg) {
            // console.log("imgLoad");
            // console.log(msg);
        }
    },
    watch: {
        cropperDialog(val) {
            this.cropperDialog2 = val;
        },
        cropperDialog2(val) {
            if (this.cropperDialog2 == false) {
                this.$emit("handle-close");
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >
.cropper {
    width: 100%;
    .info {
        width: 720px;
        margin: 0 auto;
        .oper-dv {
            height: 20px;
            text-align: right;
            margin-right: 100px;
            a {
                font-weight: 500;
                &:last-child {
                    margin-left: 30px;
                }
            }
        }

        .info-item {
            margin-top: 15px;

            label {
                display: inline-block;
                width: 100px;
                text-align: right;
            }
            .sel-img-dv {
                position: relative;
                .sel-file {
                    position: absolute;
                    width: 90px;
                    height: 30px;
                    opacity: 0;
                    cursor: pointer;
                    z-index: 2;
                }
                .sel-btn {
                    position: absolute;
                    cursor: pointer;
                    z-index: 1;
                }
            }
        }
    }
    .btnLabel {
        color: white;
        background-color: #409eff !important;
        margin: 3px 0;
        font-size: 14px;
        border-radius: 4px;
        cursor: pointer;
        height: 28px;
        margin: 3px 0;
    }
    .icons {
        display: flex;
        justify-content: center;
    }
    .oper {
        height: 28px !important;
        width: 28px !important;
        outline: none !important;
        -webkit-appearance: none !important;
        background: #409eff;
        border: 0px;
        color: white;
        border-radius: 4px;
    }
    .uploadBtn {
        height: 28px !important;
        width: 70px !important;
        outline: none !important;
        -webkit-appearance: none !important;
        background: #409eff;
        border: 0px;
        color: white;
        border-radius: 4px;
        padding: 0;
        line-height: 28px;
        vertical-align: middle;
        text-align: center;
        margin-top: 3px;
    }
}
.crop-info[data-v-6dae58fd] {
    display: none;
}
.cropper-content {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    .cropper {
        width: 260px;
        height: 260px;
    }
    .show-preview {
        flex: 1;
        -webkit-flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        -webkit-justify-content: center;
        .preview {
            overflow: hidden;
            //   border-radius: 50%;
            border: 1px solid #cccccc;
            background: #cccccc;
            margin-left: 40px;
        }
    }
}
.cropper-content .show-preview .preview {
    margin-left: 0;
}
</style>

